import React from 'react';
import Navigation from '../components/Navigation';
import SponsorshipForm from '../components/SponsorshipForm';
import SponsorIncentives from '../components/SponsorIncentives';
import SmallHero from '../components/SmallHero';

const Sponsorship: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50">
      <Navigation />
      <SmallHero 
        title="Become a Sponsor" 
        subtitle="Join leading technology companies in supporting Europe's Premier Language Intelligence Conference at the Austrian Parliament."
      />
      <div className="max-w-7xl mx-auto py-12 px-4">
        {/* Incentives Section */}
        <SponsorIncentives />

        {/* Sponsorship Packages */}
        <div className="max-w-4xl mx-auto my-12">
          <h2 className="text-2xl font-bold mb-6 text-center bg-gradient-to-r from-[#00529B] to-[#E31D3C] bg-clip-text text-transparent">
            Sponsorship Packages
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-xl border-2 border-[#00529B] transform md:-translate-y-4 hover:shadow-2xl transition-all duration-300">
              <div className="absolute top-0 right-0 bg-gradient-to-r from-[#00529B] to-[#E31D3C] text-white px-3 py-1 text-sm rounded-bl">
                Premium
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Gold</h3>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li>• 3 conference passes</li>
                <li>• 5 discount codes (-40%) for contacts</li>
                <li>• 30 minutes speaker slot*</li>
                <li>• Logo on conference website</li>
                <li>• 3 social media blasts</li>
                <li>• Blog article on LinkedIn, LI@Work, NewsFlash</li>
                <li>• Interview on LinkedIn & LI@Work</li>
                <li>• NewsFlash/video interview on LTI YouTube</li>
                <li>• Poster in conference venue</li>
                <li>• Marketing material with conference material</li>
              </ul>
              <p className="text-lg font-bold text-gray-800">Full Price: <span className="text-2xl font-bold bg-gradient-to-r from-[#00529B] to-[#E31D3C] bg-clip-text text-transparent">€6500</span></p>
              <div className="mt-2 p-2 bg-gray-50 rounded-md">
                <p className="text-sm font-medium text-gray-700">Member Pricing:</p>
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm font-medium text-gray-600">LT-INNOVATE REGULAR</span>
                  <span className="text-sm font-semibold text-[#00529B]">€4500</span>
                </div>
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm font-medium text-gray-600">LT-INNOVATE PREMIUM</span>
                  <span className="text-sm font-semibold text-[#00529B]">€4000</span>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Silver</h3>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li>• 2 conference passes</li>
                <li>• 3 discount codes (-40%) for contacts</li>
                <li>• 20 minutes speaker slot</li>
                <li>• Logo on conference website</li>
                <li>• 2 social media blasts</li>
                <li>• Blog article on LinkedIn, LI@Work, NewsFlash</li>
                <li>• Interview on LinkedIn</li>
                <li>• Poster in conference venue</li>
              </ul>
              <p className="text-lg font-bold text-gray-800">Full Price: <span className="text-2xl font-bold bg-gradient-to-r from-[#00529B] to-[#E31D3C] bg-clip-text text-transparent">€5300</span></p>
              <div className="mt-2 p-2 bg-gray-50 rounded-md">
                <p className="text-sm font-medium text-gray-700">Member Pricing:</p>
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm font-medium text-gray-600">LT-INNOVATE REGULAR</span>
                  <span className="text-sm font-semibold text-[#00529B]">€3000</span>
                </div>
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm font-medium text-gray-600">LT-INNOVATE PREMIUM</span>
                  <span className="text-sm font-semibold text-[#00529B]">€2000</span>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Bronze</h3>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li>• 1 conference pass</li>
                <li>• 1 discount code (-40%) for contacts</li>
                <li>• 10 minutes speaker slot</li>
                <li>• Logo on conference website</li>
                <li>• 1 social media blast</li>
                <li>• Poster in conference venue</li>
              </ul>
              <p className="text-lg font-bold text-gray-800">Full Price: <span className="text-2xl font-bold bg-gradient-to-r from-[#00529B] to-[#E31D3C] bg-clip-text text-transparent">€2530</span></p>
              <div className="mt-2 p-2 bg-gray-50 rounded-md">
                <p className="text-sm font-medium text-gray-700">Member Pricing:</p>
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm font-medium text-gray-600">LT-INNOVATE REGULAR+</span>
                  <span className="text-sm font-semibold text-[#00529B]">€2000</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 text-sm text-gray-600 max-w-4xl mx-auto">
            <p>* Alternatively, Gold Sponsors have the opportunity to participate in the definition of a themed session (1 hour) including the selection of speakers together with the organisers.</p>
            <p>** The subject of the blog article must be related to the event programme and must not be a commercial pitch.</p>
            <p>*** Excluding VAT (20%) on conference ticket costs</p>
            <p>**** Check out the advantages of LT-Innovate Premium & Regular <a href="https://www.lt-innovate.org/page/become-member" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Membership</a> on our website.</p>
            
            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-100 flex items-center justify-between">
              <div>
                <h4 className="font-semibold text-[#00529B] mb-1">Download Sponsorship & Visibility Pack</h4>
                <p className="text-gray-700">Get detailed information about all sponsorship opportunities in our comprehensive PDF guide.</p>
              </div>
              <a 
                href="/LI25Sponsoring&VisibilityPack0.2.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center px-4 py-2 bg-[#00529B] text-white rounded-md hover:bg-[#003D74] transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
                Download PDF
              </a>
            </div>
          </div>
        </div>

        {/* Sponsorship Form */}
        <div className="mt-12">
          <SponsorshipForm />
        </div>
      </div>
    </div>
  );
};

export default Sponsorship;
